import React from "react";
import { Tooltip, IconButton } from "@mui/material";

export default function ButtonIcon({
  icon,
  onClick,
  tooltipTitle,
  top,
  right,
  isNight = false,
}) {
  return (
    <>
      {/* Floating Icon (your exact style) */}
      <Tooltip title={tooltipTitle}>
        <IconButton
          onClick={onClick}
          sx={{
            position: "absolute",
            top: top,
            right: right,
            zIndex: 1,
            color: isNight ? "#eef2f7" : "rgba(0,0,0,0.5)",
            background: isNight ? "#848ba1" : "#fff",
            "&:hover": {
              background: isNight
                ? "rgba(78, 88, 108, 0.92)"
                : "rgba(255, 255, 255, 0.7)",
            },
            transition: "color 0.35s ease, background-color 0.35s ease",
            borderRadius: "2px",
            boxShadow: "#0000001a 0px 0px 50px 0px",
            padding: "3px",
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>
    </>
  );
}
